module.exports = __webpack_public_path__ + "media/svg/sy-6d7188f8.svg";